module.exports = __webpack_public_path__ + "images/file_icons_v2/css-79a74f300e1e6d81bfcaad4dd70130f0.svg";